// src/AllComponents/Product.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import BaseUrl from "./Baseurl/Api";
import "../global.css";

const Product = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 450, settings: { slidesToShow: 1 } },
    ],
  };

  const [sections, setSections] = useState([]);
  const [products, setProducts] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [hovered, setHovered] = useState(null);

  const productImageBaseUrl = `${BaseUrl.defaults.baseURL}/productimage/`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const homepageRes = await BaseUrl.get("/api/get_homepage");
        if (homepageRes.data.status === "success")
          setSections(homepageRes.data.section);

        const productRes = await BaseUrl.get("/api/get_allproduct");
        if (productRes.data.status === "success")
          setProducts(productRes.data.product);

        const inventoryRes = await BaseUrl.get("/api/get_inventoryData");
        if (inventoryRes.data.status === "success")
          setInventory(inventoryRes.data.inventorydata);
      } catch (error) {
        console.error("API Error:", error);
      }
    };
    fetchData();
  }, []);

  const findInventory = (id) =>
    inventory.find((inv) => inv.pid?.toString() === id?.toString()) || null;

  const formatPrice = (p) => (p ? `Rs. ${Number(p).toFixed(2)}` : "Rs. 0.00");

  return (
    <>
      <style>{`
        .product-section {
          background: var(--bg-light);
          padding: var(--space-lg) 0;
        }
        .product-heading {
          text-align: center;
          font-weight: 700;
          font-size: var(--font-xl);
          color: var(--color-text);
          margin-bottom: var(--space-xs);
        }
        .section-svg {
          display: block;
          margin: 0.4rem auto;
          max-width: 180px;
        }
        .section-sub {
          text-align: center;
          color: var(--color-muted);
          font-size: var(--font-md);
          margin-top: 0.5rem;
        }
        .section-desc {
          text-align: center;
          font-size: 1.4rem;
          color: var(--color-text);
          max-width: 700px;
          margin: -1.3rem auto var(--space-md);
          line-height: 1.6;
        }
        .card-wrap {
          padding: var(--space-sm);
        }
        .t4s-product {
          background: var(--bg-light);
          overflow: hidden;
          position: relative;
          padding: var(--padding-card);
          box-shadow: var(--box-shadow-card);
          transition: transform .2s ease, box-shadow .2s ease;
          border-radius: var(--radius-sm);
        }
        .t4s-product:hover {
          transform: translateY(-6px);
          box-shadow: var(--box-shadow-hover);
        }
        .t4s-product-img {
          width: 100%;
          aspect-ratio: 1/1;
          position: relative;
          overflow: hidden;
          border-radius: var(--radius-sm);
          background: var(--color-accent);
        }
        .t4s-product-img img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: opacity .2s ease;
        }
        .t4s-product-hover-img {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          opacity: 0;
        }
        .t4s-product-img:hover .t4s-product-hover-img {
          opacity: 1;
        }
        .badge-left {
          position: absolute;
          top: 12px; left: 12px;
          background: var(--color-ternary);
          color: var(--color-secondary);
          padding: 4px 10px;
          border-radius: var(--radius-sm);
          font-weight: 700;
          font-size: var(--font-xs);
        }
        .discount-wedge {
          position: absolute;
          top: 12px; right: 12px;
          background: #ff6b6b;
          color: var(--color-secondary);
          padding: 4px 10px;
          border-radius: var(--radius-sm);
          font-weight: 700;
          font-size: var(--font-xs);
        }
        .t4s-atc-bar {
          display: flex;
          gap: var(--space-sm);
          position: absolute;
          left: 12px;
          right: 12px;
          bottom: 12px;
          opacity: 0;
          transform: translateY(10px);
          transition: opacity .2s ease, transform .2s ease;
        }
        .t4s-product:hover .t4s-atc-bar {
          opacity: 1;
          transform: translateY(0);
        }
        .t4s-atc-bar a {
          flex: 1;
          display: flex;
        }
        .atc-btn, .buy-btn {
          flex: 1;
          height: 40px;
          border-radius: var(--border-radius-btn);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          border: 0;
          cursor: pointer;
        }
        .atc-btn {
          background: var(--color-primary);
          color: var(--color-secondary);
        }
        .atc-btn:hover {
          background: var(--bg-main);
        }
        .buy-btn {
          background: var(--color-ternary);
          color: var(--color-secondary);
        }
        .buy-btn:hover {
          background: var(--color-dark-ternary);
        }
        .t4s-product-info {
          margin-top: var(--space-sm);
          text-align: center;
        }
        .t4s-product-title {
          font-weight: 700;
          font-size: var(--font-sm);
          color: var(--color-text);
          margin: var(--space-xs) 0;
        }
        .t4s-product-price {
          margin-top: var(--space-xs);
        }
        .t4s-product-price del {
          color: var(--color-muted);
          margin-right: 8px;
          text-decoration: line-through;
        }
        .t4s-product-price ins {
          color: var(--color-primary);
          font-weight: 800;
          text-decoration: none;
        }
        .rating-row {
          margin-top: var(--space-xs);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: var(--space-xs);
        }
        .stars {
          color: var(--color-ternary);
          font-size: var(--font-sm);
        }
        .rev-count {
          color: var(--color-muted);
          font-size: var(--font-xs);
        }
      `}</style>

      <section className="product-section">
        <div className="container">
          {sections.map((sec) => {
            const catIds = sec.productcategory
              ? sec.productcategory.split(",").map((s) => s.trim())
              : [];
            const filtered = products.filter((p) =>
              catIds.includes(p.id?.toString())
            );
            if (!filtered.length) return null;

            return (
              <div key={sec.id} className="mb-5">
                <h1 className="product-heading">
                  <span>{sec.title}</span>
                  <img
                    src="https://ueirorganic.com/cdn/shop/t/39/assets/svg_title.svg"
                    alt="decorative underline"
                    className="section-svg"
                  />
                </h1>
                <p className="section-sub">{sec.subtitle || ""}</p>
                <p className="section-desc">
                  Elevate your health with our organic delights – Shop now and
                  experience the natural difference
                </p>

                <Slider {...settings}>
                  {filtered.map((prod) => {
                    const inv = findInventory(prod.id);
                    const compareP = inv?.compare_price ?? inv?.mrp ?? null;
                    const priceP = inv?.price ?? inv?.selling_price ?? null;
                    let discountPercent = null;
                    if (compareP && priceP && Number(compareP) > Number(priceP)) {
                      discountPercent = Math.round(
                        ((compareP - priceP) / compareP) * 100
                      );
                    }

                    const mainImg = prod.productImage?.startsWith("http")
                      ? prod.productImage
                      : `${productImageBaseUrl}${prod.productImage || ""}`;

                    const hoverImg = prod.image2
                      ? prod.image2.startsWith("http")
                        ? prod.image2
                        : `${productImageBaseUrl}${prod.image2}`
                      : mainImg;

                    return (
                      <div className="card-wrap" key={prod.id}>
                        <div
                          className="t4s-product"
                          onMouseEnter={() => setHovered(prod.id)}
                          onMouseLeave={() => setHovered(null)}
                        >
                          {prod.isBestseller && (
                            <div className="badge-left">Bestseller</div>
                          )}
                          {discountPercent && (
                            <div className="discount-wedge">
                              -{discountPercent}%
                            </div>
                          )}

                          <div className="t4s-product-img">
                            <img
                              alt={prod.productName}
                              src={mainImg}
                              style={{ opacity: hovered === prod.id ? 0 : 1 }}
                              onError={(e) =>
                                (e.target.src =
                                  "https://via.placeholder.com/600x600?text=No+Image")
                              }
                            />
                            <img
                              alt={`${prod.productName} hover`}
                              className="t4s-product-hover-img"
                              src={hoverImg}
                              onError={(e) => (e.target.src = mainImg)}
                            />
                            <div className="t4s-atc-bar">
                              <Link
                                to={`/productdetails/${prod.id}`}
                                style={{ textDecoration: "none" }}
                              >
                                <button className="atc-btn">ADD TO CART</button>
                              </Link>
                              <Link
                                to={`/productdetails/${prod.id}`}
                                style={{ textDecoration: "none" }}
                              >
                                <button className="buy-btn">BUY NOW</button>
                              </Link>
                            </div>
                          </div>

                          <div className="t4s-product-info">
                            <h3 className="t4s-product-title">
                              <Link
                                to={`/productdetails/${prod.id}`}
                                style={{
                                  color: "inherit",
                                  textDecoration: "none",
                                }}
                              >
                                {prod.productName}
                              </Link>
                            </h3>
                            <div className="t4s-product-price">
                              {compareP && <del>{formatPrice(compareP)}</del>}
                              <ins className="fs-lg">
                                {priceP
                                  ? formatPrice(priceP)
                                  : formatPrice(prod.price)}
                              </ins>
                            </div>
                            <div className="rating-row">
                              <div className="stars">★★★★★</div>
                              <div className="rev-count">
                                {prod.reviewsCount || "0"} reviews
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default Product;
